import React, { useState, useRef, useEffect } from "react";
import { FaCalendarAlt, FaTimes } from "react-icons/fa";
import {
  DateFilterContainer,
  DateFilterButton,
  DateFilterDropdown,
  DateInput,
  DateInputGroup,
  DateLabel,
  ClearButton,
  ApplyButton,
  DateFilterActions,
} from "./CustomDateFilter.styles";

const CustomDateFilter = ({
  dateFrom,
  dateTo,
  onDateChange,
  placeholder = "Filtriraj po datumu",
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [tempDateFrom, setTempDateFrom] = useState(dateFrom || "");
  const [tempDateTo, setTempDateTo] = useState(dateTo || "");
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleApply = () => {
    onDateChange(tempDateFrom, tempDateTo);
    setIsOpen(false);
  };

  const handleClear = () => {
    setTempDateFrom("");
    setTempDateTo("");
    onDateChange("", "");
    setIsOpen(false);
  };

  const hasFilter = dateFrom || dateTo;
  const displayText = hasFilter
    ? `${dateFrom ? new Date(dateFrom).toLocaleDateString("sr-latn-RS") : ""} - ${dateTo ? new Date(dateTo).toLocaleDateString("sr-latn-RS") : ""}`
    : placeholder;

  return (
    <DateFilterContainer ref={dropdownRef}>
      <DateFilterButton
        $active={isOpen || hasFilter}
        onClick={() => setIsOpen(!isOpen)}
      >
        <FaCalendarAlt />
        <span>{displayText}</span>
        {hasFilter && (
          <ClearButton
            onClick={(e) => {
              e.stopPropagation();
              handleClear();
            }}
          >
            <FaTimes />
          </ClearButton>
        )}
      </DateFilterButton>

      {isOpen && (
        <DateFilterDropdown>
          <DateInputGroup>
            <DateLabel>Od datuma:</DateLabel>
            <DateInput
              type="date"
              value={tempDateFrom}
              onChange={(e) => setTempDateFrom(e.target.value)}
              max={tempDateTo || new Date().toISOString().split("T")[0]}
            />
          </DateInputGroup>

          <DateInputGroup>
            <DateLabel>Do datuma:</DateLabel>
            <DateInput
              type="date"
              value={tempDateTo}
              onChange={(e) => setTempDateTo(e.target.value)}
              min={tempDateFrom}
              max={new Date().toISOString().split("T")[0]}
            />
          </DateInputGroup>

          <DateFilterActions>
            <ClearButton onClick={handleClear}>Obriši</ClearButton>
            <ApplyButton onClick={handleApply}>Primeni</ApplyButton>
          </DateFilterActions>
        </DateFilterDropdown>
      )}
    </DateFilterContainer>
  );
};

export default CustomDateFilter;
